import { IEnvironment } from './tenant.model';

export const environment: IEnvironment = {
  production: false,

  baseApiUrl: 'https://dev.avaana.com.au',
  baseCorporateWellbeingUrl: 'https://corporate-wellbeing.avaana.com.au',
  baseLogicHeathApiUrl: 'https://api-qa-logichealth.avaana.com.au',
  baseEMLWorkcoverUrl: 'https://api-qa-eml.avaana.com.au',
  baseTRINITYWorkcoverUrl: 'https://api-qa-trinity.avaana.com.au',
  baseHIIWorkcoverUrl: 'https://api-qa-hii.avaana.com.au',
  baseBlogUrl: 'https://avaana.com.au/blog',

  baseOwnWorkcoverUrl: 'https://api-qa-hii.avaana.com.au',

  appName: 'HII-QA',

  auth0: {
    domain: 'hii-dev-auth.au.auth0.com',
    clientId: 'djLAWeUfTcd5vekdEddWVvi0pgl8VY8c'
  },

  sentry: {
    dsn: 'https://99fc39594eceaa5e75d076866e72e4be@o4507179659624448.ingest.us.sentry.io/4511064733974528',
    tracePropagationTargets: ['https://avaana.com.au', 'https://qa-hii.avaana.com.au']
  },

  clarity: {
    projectId: ''
  },

  gtmId: '',
  googleMapsApiKey: 'AIzaSyCbfv-NcSLHO0FJo90VA0lfR5kflxcpcso',

  mapbox: {
    accessToken: 'pk.eyJ1Ijoia2FtYWwyNzMwIiwiYSI6ImNscjdld210MjIydnMya3BubmN5MG5hbmsifQ.6hr-rtyierLdnUWUK7C9sw',
    style: 'mapbox://styles/kamal2730/clywpcs48008001p6ar1xgizx'
  },

  intercom: {
    appId: 'tl9uvp8y',
    secretKey: 'Rv9dmgDL53AXEhR6HMj7bBIFt_Hkoek4Z7jJi_2-'
  },

  googleAuth: {
    CLIENT_ID: '',
    API_KEY: ''
  },

  branding: {
    title: 'HII',
    faviconAsset: './assets/images/tenants/hii/hii.ico',
    logoAsset: './assets/images/tenants/hii/hii-logo-avaana.svg',
    logoMobileAsset: './assets/images/tenants/hii/hii-logo.png',
    logoWhiteAsset: 'assets/images/tenants/hii/hii-logo-white.png',
    themeColor: '#ffffff'
  },

  recaptchaKey: '6LdGcUwtAAAAAFdzRwq0yw6OUnc_cep39a3SqSfl'
};
